<template>
    <el-dropdown trigger="click" class="pr-4">
        <div class="menu-header">
            <img class="pr-4" src="@/assets/icons/user.svg" height="30" width="30" />
            <span v-if="loggedIn" class="user-name center-h">{{ name }}</span>
            <span v-else class="user-name center-h">-</span>
        </div>
        <template #dropdown>
        <el-dropdown-menu v-if="loggedIn">
            <a href='Session/SignOut'><el-dropdown-item>Sign out</el-dropdown-item></a>
            <a href='Session/EditProfile'><el-dropdown-item>Edit Profile</el-dropdown-item></a>
            <a href='Session/ResetPassword'><el-dropdown-item>Reset Password</el-dropdown-item></a>
        </el-dropdown-menu>
        <el-dropdown-menu v-else>
            <a href='Session/SignIn'><el-dropdown-item>Sign in</el-dropdown-item></a>
        </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<style lang="scss" scoped>
.menu-header {
    display: flex;
}

.center-h {
    align-self: center;
}

.el-dropdown {
    cursor: pointer;
}

</style>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'user-menu',
    computed: {
        loggedIn(): boolean {
            return this.$store.state.user.loggedIn;
        },
        name(): string {
            return this.$store.state.user.name;
        },
    },
});
</script>
